'use strict';

/* CQ Article Service */

import ScriptLoader from "../../fsUtils/ScriptLoader";

angular.module('storyApp').factory('cqArticleService', ['$http', '$q', function($http, $q) {

    var service = {
        
        articles: [],
        urls: [],
        onRenderArticle: null,
        
        addArticle: function(url, articleUrl){
            
            var that = this;
            
            that.articles.push({
                'url': url,
                'articleUrl': articleUrl,
                'isFetched' : false,
                'isFetching' : false,
                'isRendered' : false,
                'content' : null,
                'metadata' : null,
                'httpPromise' : null
            });
            
            return that;
        },
        addArticleContent: function(relatedIndex, content){
            
            var that = this;
            
            that.articles[relatedIndex].content = content;
            
            return that;
            
        },
        getUrl: function(relatedIndex){
            var that = this;
            
            return that.articles[relatedIndex].url;
        },
        
        getArticleUrl: function(relatedIndex){
            var that = this;
            
            return that.articles[relatedIndex].articleUrl;
        },
        
        fetchArticle: function(relatedIndex) {
            
            var deferred = $q.defer(),
                that = this,
                url = that.getArticleUrl(relatedIndex);
                
            //check first if article have been fetched    
            if(!that.articles[relatedIndex].isFetched){
                
                 /** 
                 ** need to watch the following logic
                 **/
                
                //mark fetch and returm promise of current ajax call
                if(that.articles[relatedIndex].isFetching){
                    
                    //console.log("being fetch for related, promise returned ", relatedIndex);
                    
                    return that.articles[relatedIndex].httpPromise;
                    
                }else{
                    
                    that.articles[relatedIndex].isFetching = true;
                    
                    //console.log("starting fetch for related ", relatedIndex);
                    
                    that.articles[relatedIndex].httpPromise = deferred.promise;
                    
                    $http({
                        method: 'GET',
                        url: url
                    }).success(function(data) {
            
                        //data = that.getMetadata(data);
                        that.addArticleContent(relatedIndex,data);
                        that.articles[relatedIndex].isFetched = true;
                        that.articles[relatedIndex].isFetching = false;
                        that.articles[relatedIndex].metadata = that.setMetadata(data);
                        
                        deferred.resolve(data);
            
                    }).error(function() {
                        deferred.reject("There was an error getting story");
                        //fallback implementation here if it is needed
                    })
            
                    return deferred.promise;
                    
                }
                
            }else{
                
                //console.log("related article is already fetched for ", relatedIndex);
                
                return that.articles[relatedIndex].httpPromise;
                
            }
            
            
        },
        getMetadata: function(relatedIndex){

            var that = this;

            return that.articles[relatedIndex].metadata;

        },
        setMetadata: function(content){
        
            //parse meta data from article API response and return an object that holds the article content and meta data
            var metadata = content.split('<script id="page-information" type="text/fs-metadata">')[1];
            metadata = metadata.split('</script>')[0];

            return JSON.parse(metadata);

        },
 
        renderArticle: function(relatedIndex, callback){

            var that = this;
            
            //check if already rendered
            if(that.articles[relatedIndex].isRendered == false && that.articles[relatedIndex].content !== null){
                
                if (that.onRenderArticle !== null && typeof that.onRenderArticle === 'function') {

                    //set callback for rendering
                    that.onRenderArticle(relatedIndex,that.articles[relatedIndex].content);

                    that.loadScriptsAfterRender(that.articles[relatedIndex].content);

                    //extra callback
                    //typeof callback === 'function' && callback();

                    //console.warn("Done rendering for related - ", relatedIndex);
                    
                    that.articles[relatedIndex].isRendered = true;

                }
                
                return true;
                
            }else{
                
                //console.log("content for " + relatedIndex + " already rendered");
                
                return false;
                
            }
            
            
        },

        loadScriptsAfterRender: function(htmlString){

            //console.log("3things - after render" , htmlString);

            var fragment = document.createDocumentFragment();
            var rootEl = document.createElement('div'); 

            rootEl.innerHTML = htmlString;
            fragment.appendChild(rootEl);

            var allScripts = [].slice.call(fragment.querySelectorAll('script:not([type*=template]):not(#page-information)'));

            let scriptLoader = new ScriptLoader();

            allScripts.map((scriptEl) => {

                if (scriptEl.src) {
                    scriptLoader.getScript(scriptEl.src, null , false);
                } else {
                    var evalScript = window.setTimeout(function(){
                        eval(scriptEl.innerText);
                        window.clearTimeout(evalScript);
                    },0);
                }
            });
            


        }
    };

    window.cqArticleService = service;


    return service;

}]);


// WEBPACK FOOTER //
// ./assets/components/threethings/factories/cqArticleService.js